import { createStructuredSelector } from 'reselect'
import { AppState } from 'Store/root-reducer'
import { linkStateToProps } from 'Features/LicenseImportOnPrem/types'

const loading = ({ licenseImportOnPrem }: AppState) => licenseImportOnPrem.getIn(['loading'], false)

export default createStructuredSelector<AppState, linkStateToProps>({
  loading
})
